export const padTwoDigits = (value: number) => String(value).padStart(2, '0')
